/**
 * UpdateNotices — the App root's two "a newer build exists" notices, in one
 * place so they cannot talk over each other.
 *
 * - <UpdateBanner>: the polite one (a new service worker is waiting; the user
 *   picks the moment).
 * - <ClientOutdatedModal>: the forced one (this build's COMPAT_LEVEL is below
 *   the live level — docs/spec/19d-client-backend-compat.md, "The modal").
 *
 * While the modal or the standing screen is up, the banner is NOT rendered: it
 * would say the same thing a second time, and the modal's own button already
 * updates. Hidden, not dismissed — useServiceWorkerUpdate re-checks the waiting
 * worker (`window.__swWaiting`) when the banner mounts again, so it comes back
 * if the modal ever goes away without a reload (the unattended standing screen).
 *
 * `compat` is the useClientCompat() result.
 */
import React from "react";
import { UpdateBanner } from "./UpdateBanner";
import { ClientOutdatedModal } from "./ClientOutdatedModal";

export function UpdateNotices({ compat }) {
  return (
    <>
      {!compat.view && <UpdateBanner />}
      <ClientOutdatedModal
        view={compat.view}
        busy={compat.busy}
        unattended={compat.unattended}
        ownLevel={compat.ownLevel}
        ownBuildId={compat.ownBuildId}
        liveLevel={compat.liveLevel}
        liveBuildId={compat.liveBuildId}
        onUpdate={compat.update}
      />
    </>
  );
}
